import { Injectable } from '@angular/core';
import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import { v4 as uuidv4 } from 'uuid';
import { ICapabilityRequestAttachment } from 'src/app/interfaces/ICapabilityRequest';
import { AppConfigService } from '../../services/app-config/app-config.service';
import { IAppConfig } from 'src/app/interfaces/IAppConfig';

/**
 * Service for interacting with Azure blob storage
 */
@Injectable({
    providedIn: 'root'
})
export class BlobUploadService {
    private _blobClient: ContainerClient;

    constructor(private _config: AppConfigService){
        this._blobClient = new BlobServiceClient((this._config.config).blob_storage.connection_string).getContainerClient('');
    }

    /**
     * Upload files to blob storage
     * @param {File[]} files Files to upload
     * @returns {Promise<ICapabilityRequestAttachment[]>} Promise returns when all files have been uploaded.
     */
    public async uploadBlob(files: File[]): Promise<ICapabilityRequestAttachment[]>{
        return new Promise(async (resolve, reject) => {

            const retArray = new Array<ICapabilityRequestAttachment>();

            for (const file of files){
                let uuidFileName = uuidv4();
                uuidFileName += `${this.getFileExtension(file.name)}`;
                const blockBlobClient = this._blobClient.getBlockBlobClient(uuidFileName);
                try{
                    await blockBlobClient.uploadData(file);
                    retArray.push({
                        name: file.name,
                        path: `${this._blobClient.url.split('?')[0]}${uuidFileName}`
                    });
                }catch (e){
                    reject(e);
                }
            }

            resolve(retArray);
        });
    }

    /**
     * Get file extension from file name, otherwise return null
     * @param fileName File Name
     * @returns {string} Extension of provided file name
     */
    public getFileExtension(fileName: string): string | null {
        const fileNameSplit = fileName.split('.');
        if (fileNameSplit.length > 1){
            return `.${fileNameSplit.pop() || ''}`;
        } else {
            return null;
        }
    }
}
